<script lang="ts">
    import TurianLogo from "./turian-logo.svelte";
    import { m } from "../../messages.svelte.js";

    const props: { message?: string } = $props();
</script>

<div class="flex size-full animate-pulse flex-col items-center justify-center gap-1">
    <TurianLogo />
    {props.message ?? m["loading"]()}
</div>
